export default "__VITE_ASSET__Bb93BDOj__"